export default __webpack_public_path__ + "static/media/461EB37B-3835-4CF1-BA39-D3B8C47C0F3F_1_105_c.9abef89d.jpeg";